import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HelpersService } from '../../../../../core/services/helpers.service';
import { FilePreviewComponent } from '../../../../../components/file-preview/file-preview.component';

@Component({
  selector: 'app-detail-approval-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './detail-approval-dialog.component.html',
  styleUrl: './detail-approval-dialog.component.scss',
})
export class DetailApprovalDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DetailApprovalDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private helpers: HelpersService,
    private dialog: MatDialog,
  ) {}

  closeDialog(): void {
    this.dialogRef.close();
  }

  getStatusLabel(): string {
    if (this.data?.status === true) return 'Approved';
    if (this.data?.status === false) return 'Rejected';
    return '-';
  }

  getStatusClass(): string {
    if (this.data?.status === true) return 'status-badge status-badge--approved';
    if (this.data?.status === false) return 'status-badge status-badge--rejected';
    return 'status-badge status-badge--pending';
  }

  formatFileSize(size?: number): string {
    if (!size) return '';
    return `${(size / 1024 / 1024).toFixed(2)} MB`;
  }

  download(): void {
    if (this.data?.approval_attachment) {
      this.dialog
        .open(FilePreviewComponent, {
          width: '70vw',
          maxWidth: '70vw',
          maxHeight: '95vh',
          data: this.data?.approval_attachment,
        })
        .afterClosed()
        .subscribe((item) => {
          if (item) {
          }
        });
      // this.loadingService.startLoading();
      // this.fileService.download(this.data?.approval_attachment?.id).subscribe(
      //   (res) => {
      //     const url = URL.createObjectURL(res);
      //     const anchor = document.createElement('a');
      //     anchor.href = url;
      //     anchor.target = '_blank';
      //     anchor.download = this.data?.approval_attachment?.fileName;
      //     anchor.click();
      //     URL.revokeObjectURL(url);
      //     this.loadingService.endLoading();
      //   },
      //   (error) => {
      //     this.loadingService.endLoading();
      //     this.helpers.sbError(error.message);
      //   }
      // );
    } else {
      this.helpers.sbError('Tidak ada file yang bisa diunduh');
    }
  }
}
